<template>
  <b-modal id="invoiceRefundModal" modal-class="client-details-modal" centered size="lg" hide-header-close hide-footer>
    <template #modal-header>
      <div class="view-clients-header">
        <b-button variant="close-btn" class="btn-container" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container fluid>
      <div class="view-clients-modal-content">
        <h6 class="modal-refund-title">Refund Payment</h6>
        <div class="addMessage-form">
          <p style="font-size: 16px;"><strong>{{ this.row?.invoice_policy_id }}</strong></p>
          <p style="font-size: 16px;"><strong>Card Number: </strong>{{ billingDetails?.card_num ? 'xxxx-' + billingDetails.card_num : 'N/A' }}</p>
          <p style="font-size: 16px;"><strong>Card Type: </strong>{{  billingDetails?.brand?billingDetails?.brand:'N/A' }}</p>
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.stop.prevent="handleSubmit(refundPayment)" ref="sendEmailContainer">
              <div class="form-group row">

                <input-text :rules="`required|isMinAmount:${remainingRefundableAmount}`" labelFor="amount"
                  labelName="Amount" inputName="beneficiary_name" :vmodel.sync="form.payamount"
                  formGroupClass="col-xxl-12 mb-3" />

                <input-text :rules="{ required: true }" labelFor="beneficiary_name" labelName="Beneficiary Name"
                  inputName="beneficiary_name" :vmodel.sync="form.payment_ben_name" formGroupClass="col-xxl-12 mb-3" />

                <input-text labelFor="invoice_end_date" labelName="Paid Through date" inputName="invoice_end_date"
                  :vmodel.sync="form.invoice_end_date" readonly formGroupClass="col-xxl-12 mb-3" />

                <div class="col-xxl-12 mb-3">
                  <validation-provider name="Payment Notes" rules="required" v-slot="{ errors }">
                    <input-textarea :rules="{ required: true }" labelFor="file" labelName="Payment Notes"
                      inputName="file" :vmodel.sync="form.notes" formGroupClass="form-group mb-3" />
                    <div class="invalid-block invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="row justify-content-md-center">
                <div class="col-xxl-5 mb-4">
                  <b-button class="univ-btn" type="submit" :disabled="isSend">
                    <template v-if="isSend"> Sending ... </template>
                    <template v-else> Send </template>
                  </b-button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <invoice-confirm-modal :billingDetails="billingDetails" :row="formData" @confirmRefundPayment="confirmRefundPay" />
    </b-container>
  </b-modal>
</template>
<script>
import axios from 'axios';
import InvoiceConfirmModal from './InvoiceConfirmModal.vue';
import { extend } from "vee-validate";
import { mapGetters } from 'vuex'; 

extend("isMinAmount", {
  validate(value, args) {
    const max = Number(args.max);
    return Number(value) <= max;
  },
  params: ["max"],
  message: "Amount must be smaller than or equal to {max}.",
});
export default {
  inject: ['getInvoiceData'],
  name: "InvoiceRefundModal",
  components: {
    InvoiceConfirmModal
  },
  props: {
    row: Object,
    refundedAmount: Object,
    billingDetails:Object
  },
  data: () => ({
    form: {
      invoice_end_date: "",
      payment_ben_name: "",
      notes: '',
      payamount: '',
      validationAmount: ''
    },
    formData: {},

    isSend: false,
  }),
  methods: {
    reset() {
      this.form = {
        invoice_end_date: "",
        payment_ben_name: "",
        notes: '',
        payamount: '',
      };
      this.$refs.observer.reset();
    },
    closeModal() {
      this.$bvModal.hide("invoiceRefundModal");
      this.$emit("onClosedModal");
    },
    refundPayment() {
      this.formData = { ...this.form, paymentID: this.row.invoice_id };
      this.$bvModal.show('invoiceConfirmModal');

    },

    confirmRefundPay() {
      let payload = {
        acc_holder_name: null,
        acc_no: null,
        ach_refno: null,
        bank_name: "",
        card_holder_name: "",
        card_no: "",
        ccv: "",
        chck_bank_name: null,
        check_no: null,
        exp_month: "",
        exp_year: "",
        invoice_due_amount: 0,
        invoice_end_date: this.form.invoice_end_date,
        invoiceid: this.row.invoice_id,
        notes: this.form.notes,
        payamount: this.form.payamount,
        payment_ben_name: this.form.payment_ben_name,
        payment_company: "NuEra Benefits Agency Inc.",
        payment_method: "cc",
        payment_status: "Success",
        refno: this.row.paystand_id,
        refundable_amount: 2316,
        routing_no: null,
        routing_no_error: "",
        user_bank_name: "",
        user_check_no: "",
        userid: this.$store.getters.repId,
      };

      this.isSend = true;
      let loader = this.$loading.show();
      axios
        .post(`${process.env.VUE_APP_CORENROLL_API_URL}makeRefundPaymentByRep`, payload)
        .then((response) => {
          console.log(response)
          this.$notify("Refund Information Successfully Updated");
          this.$emit("refundedAmount", this.form.payamount, this.row.invoice_id);
        })
        .catch((error) => {
          console.error(error)
          this.$notify("Cannot update Refund Information", "error");
        })
        .finally(() => {
          this.isSend = false;
          loader.hide();
          this.closeModal();
          this.reset();
          this.getInvoiceData()
        });
    }
  },
  computed: {
    ...mapGetters(["getRefundedAmount"]),
    beneficiaryName() {
      return `${this.row?.cfname} ${this.row?.clname} `
    },
    remainingRefundableAmount() {
      if (!this.row || !this.row.invoice_id) return 0;

      const totalPolicyAmount = parseFloat(this.row.policy_amount.replace(/[$,]/g, '')) || 0;
      const totalRefunded = this.getRefundedAmount(this.row.invoice_id) || 0; // Access refunded amount from Vuex store

      return Math.max(0, totalPolicyAmount - totalRefunded);
    }

  },

  mounted() {

    if (this.row) {
      this.form.payment_ben_name = this.row?.cfname && this.row?.clname
        ? `${this.row?.cfname} ${this.row?.clname}`
        : "";
    }
  },
  watch: {
    row: {
      handler(newRow) {
        this.form.invoice_end_date = this.row.invoice_end_date || "";
        this.form.payamount = this.row.policy_amount 
    ? parseFloat(this.row.policy_amount.replace(/[$,]/g, '')) - (this.refundedAmount || 0)
    : "";
        if (newRow && newRow.cfname && newRow.clname) {
          this.form.payment_ben_name = `${newRow.cfname} ${newRow.clname}`;
        }
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>

<style>
.modal-refund-title {
  font-size: 22px;
  text-align: center;
}

.addMessage-form label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
</style>